import { Card, Checkbox, Row, Col } from "antd";
import { JobStatus, JobStatusDescriptions } from "api/services/models/types";

interface JobStatusFilterProps {
  selectedJobStatuses?: JobStatus[];
  onJobStatusChange: (value: JobStatus[] | undefined) => void;
}

const JobStatusFilter = ({ 
    selectedJobStatuses = [], 
    onJobStatusChange 
  }: JobStatusFilterProps) => {
    const allStatuses = [JobStatus.None, JobStatus.Ready, JobStatus.QCHold, JobStatus.Archived];

    const handleCheckboxChange = (status: string) => {
      if (status === "All") {
        if (selectedJobStatuses.includes(JobStatus.None)) {
          onJobStatusChange([]);
        } else {
          onJobStatusChange(allStatuses.slice(1));
        }
      } else {
        const statusValue = Number(status);
        const newSelectedStatuses = selectedJobStatuses.includes(statusValue)
          ? selectedJobStatuses.filter(s => s !== statusValue)
          : [...selectedJobStatuses, statusValue];

        onJobStatusChange(newSelectedStatuses);

        if (newSelectedStatuses.length < 3) {
          onJobStatusChange(newSelectedStatuses.filter(s => s !== JobStatus.None));
        }
      }
    };

    const isAllSelected = selectedJobStatuses.length === allStatuses.length - 1;

    return (
      <Card
        styles={{ body: { padding: "16px" } }}
        className={`service-filter-card`}>
        <span className="job-status-filter-title">Job Status</span>
        <Row gutter={[8, 12]} style={{ marginTop: "12px" }}>
          <Col xs={24} sm={12}>
            <Checkbox
              checked={isAllSelected}
              onChange={() => handleCheckboxChange("All")}
              className="job-status-filter-checkbox">
              All
            </Checkbox>
          </Col>
          {allStatuses.slice(1).map(status => (
            <Col xs={24} sm={12} key={status}>
              <Checkbox
                checked={selectedJobStatuses.includes(status)}
                onChange={() => handleCheckboxChange(status.toString())}
                className="job-status-filter-checkbox">
                {JobStatusDescriptions[status]}
              </Checkbox>
            </Col>
          ))}
        </Row>
      </Card>
    );
  };

export default JobStatusFilter;
